import {Display} from "./Display";
import {Slider} from "./Slider";
import {Video} from "./Video";

// noinspection JSUnresolvedVariable,JSUnresolvedFunction
export class Basic
{
    static init()
    {
        Basic.base = '/';
        Basic.lang = 'de';
        Basic.resizeTimer = 0;
        Basic.ise = (document.body.dataset.ise === 'on');
    }

    static add_clickEvent()
    {
        document.body.addEventListener('click',e =>
        {
            let el = e.target;

            if(el.classList.contains('ise') || el.closest('.ise'))
            {
                return false;
            }
            else if(el.closest('.w__js-button'))
            {
                el = el.closest('.w__js-button');
            }

            if(el.classList.contains('w__js-button') &&
               el.dataset.f)
            {
                e.preventDefault();

                switch(el.dataset.f)
                {
                    case 'move-slider':
                        Slider.move(el);
                        break;

                    case 'video':
                        new Video(el);
                        break;

                    default:
                        console.log('Missing case: ' + el.dataset.f);
                }
            }
        });
    }

    static process_resize()
    {
        Display.analyze();
        new Slider();
    }
}

